<template>
    <div id="search-result" class="section-inner l-centered">
        <div v-if="rows.length && !loading" class="search-result">
            <div class="search-result-header">
                
                <search-export-menu></search-export-menu>

                <a id="export" download="" href="" style="display: none;"></a>

                <search-pagination></search-pagination>

                <div class="clear-fix"></div>

                <div class="search-result-progress"><p></p></div>
            </div>

            <search-export-csv></search-export-csv>

            <div class="search-result-body">
                <div class="search-result-menu">
                    <div class="search-result-menu-view">
                        <h6 v-if="pagination.rows_count > 100000">
                            Найдено более 100 000
                            <br>
                            Уточните свой запрос
                        </h6>
                        <h6 v-else>
                            Найдено {{pagination.rows_count}}
                        </h6>
                    </div>
                    
                    <div class="search-result-menu-view">
                        <h6>Отображение результатов</h6>
                        <span v-on:click="resultViewChange" v-bind:class="{on: computedListView}" data-view="list">списком</span>
                        <span v-on:click="resultViewChange" v-bind:class="{on: !computedListView}" data-view="table">таблицей</span>
                    </div>

                    <div class="search-result-menu-count">
                        <h6>Результатов на странице</h6>
                        <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 100}" data-count="100">100</span>
                        <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 250}" data-count="250">250</span>
                        <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 500}" data-count="500">500</span>
                        <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 1000}" data-count="1000">1000</span>
                    </div>

                    <div class="search-result-menu-type">
                        <h6>Поиск</h6>
                        <span data-tsv="tsv_all" v-on:click="tsvClickHandle" v-bind:class="{on: searchtype == 'tsv_all'}">везде</span>
                        <span data-tsv="tsv_names" v-on:click="tsvClickHandle" v-bind:class="{on: searchtype == 'tsv_names'}">только в названиях</span>
                    </div>
                </div>

                <shestirenka v-if="loading" />
                <search-result-list v-else :computedListView="computedListView"></search-result-list>
                <div class="search-result-menu-count">
                    <h6>Результатов на странице</h6>
                    <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 100}" data-count="100">100</span>
                    <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 250}" data-count="250">250</span>
                    <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 500}" data-count="500">500</span>
                    <span v-on:click="limitNumberClick" v-bind:class="{on: limit == 1000}" data-count="1000">1000</span>
                </div>
            </div>
            <div class="clear-fix"></div>
        </div>
        <div v-else-if="loading" class="search-not-found">
            <shestirenka/>
        </div>
        <div v-else-if="!loading && !rows.length" class="search-not-found" style="display: block;">Ничего не найдено</div>
    </div>
</template>

<script>
import searchExportMenu from './searchExportMenu.vue'
import searchExportCsv from "./searchExportCsv.vue"
import searchResultList from "./searchResultList.vue"
import searchPagination from "./searchPagination.vue"
import shestirenka from './../ui/shestirenkaLoader.vue'

export default {
    data() {
        return {
            resultListView: 'list'
        }
    },
    components: {
        "search-export-menu": searchExportMenu,
        "search-export-csv": searchExportCsv,
        "search-result-list": searchResultList,
        "search-pagination": searchPagination,
        shestirenka
    },
    computed: {
        pagination() { return this.$store.state.search.pagination },
        searchtype() { return this.$store.state.search.filterData.searchtype },
        loading(){ return this.$store.state.search.loading },
        computedListView(){ return this.$data.resultListView == 'list' ? true : false },
        limit(){ return this.$store.state.search.pagination.limit },
        rows(){ return this.$store.state.search.rows },
        loading(){ return this.$store.state.search.loading }
    },
    methods: {
        tsvClickHandle(e) {
            this.$store.commit('search/setFilterData', {
                type: "searchtype",
                value: e.target.getAttribute('data-tsv')
            })
        },
        limitNumberClick(e){
            this.$store.commit('search/resetPage')
            this.$store.dispatch('search/changePagination', {
                type: "limit",
                data: e.target.getAttribute('data-count')
            })
        },
        resultViewChange(e){
            this.$data.resultListView = e.target.getAttribute('data-view')
        }
    }
}
</script>

<style scoped>
.search-result-header-title { width: 160px; float: left; font-size: 18px; white-space: nowrap; }
.search-not-found {
    margin: 100px 0 !important;
}
</style>
